export default __webpack_public_path__ + "static/media/XuaiiOn.84e21e4a.png";